/* Landing Trotadora Spirit XT285 - VOLT Fitness Chile - v7 */
(function(){
var r=document.getElementById('xt');if(!r)return;
var rm=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var IO=window.IntersectionObserver;

/* ---------- 1. HIDRATACIÓN: imágenes, links, precio, PDF ---------- */
function hydrate(){
  var m=window.XT285_IMG||{},L=window.XT285_LINKS||{},P=window.XT285_PRECIO||{},pdf=window.XT285_PDF;
  r.querySelectorAll('[data-img]').forEach(function(e){var s=m[e.dataset.img];if(s&&e.src!==s)e.src=s});
  r.querySelectorAll('[data-bg]').forEach(function(e){var s=m[e.dataset.bg];if(s)e.style.backgroundImage='url("'+s+'")'});
  r.querySelectorAll('[data-href]').forEach(function(e){if(L[e.dataset.href])e.href=L[e.dataset.href]});
  if(P.actual)r.querySelectorAll('[data-price]').forEach(function(e){e.textContent=P.actual});
  r.querySelectorAll('[data-price-old]').forEach(function(e){
    if(P.antes){e.textContent=P.antes}else{e.style.display='none'}});
  r.querySelectorAll('[data-cuota]').forEach(function(e){e.textContent=P.cuota||''});
  r.querySelectorAll('[data-pdf]').forEach(function(e){
    if(pdf){e.href=pdf}else{e.style.display='none'}});
}
hydrate();

/* ---------- 2. TÍTULO PALABRA POR PALABRA ---------- */
r.querySelectorAll('[data-split]').forEach(function(el){
  if(rm)return;
  el.innerHTML=el.textContent.trim().split(' ').map(function(w,i){
    return '<span class="x-sp"><i style="transition-delay:'+(i*.09)+'s">'+w+'</i></span>';
  }).join(' ');
  requestAnimationFrame(function(){requestAnimationFrame(function(){
    el.querySelectorAll('.x-sp').forEach(function(s){s.classList.add('x-on')});
  })});
});

/* ---------- 3. REVEAL AL SCROLL ---------- */
var rv=r.querySelectorAll('.x-rv,.x-msk,.x-ss');
if(IO&&!rm){
  var io=new IO(function(e){e.forEach(function(x){
    if(x.isIntersecting){x.target.classList.add('x-on');io.unobserve(x.target)}
  })},{threshold:.1,rootMargin:'0px 0px -60px'});
  rv.forEach(function(el){io.observe(el)});
}else{rv.forEach(function(el){el.classList.add('x-on')})}

/* ---------- 4. CONTADORES ---------- */
if(IO&&!rm){
  var ci=new IO(function(e){e.forEach(function(x){
    if(!x.isIntersecting)return;ci.unobserve(x.target);
    var el=x.target,end=parseFloat(el.dataset.num),
        dec=(el.dataset.num.split('.')[1]||'').length,t0=null;
    requestAnimationFrame(function s(t){
      if(!t0)t0=t;var p=Math.min(1,(t-t0)/1100);
      el.textContent=(end*(1-Math.pow(1-p,3))).toFixed(dec).replace('.',',');
      if(p<1)requestAnimationFrame(s);
    });
  })},{threshold:.6});
  r.querySelectorAll('[data-num]').forEach(function(el){ci.observe(el)});
}

/* ---------- 5. NAV STICKY + BARRA MOBILE + PROGRESO ---------- */
var nv=r.querySelector('[data-nav]'),hr=r.querySelector('[data-hero]'),
    pg=r.querySelector('[data-prg]'),cb=r.querySelector('[data-cta-bar]');
if(IO&&hr){
  new IO(function(e){
    var out=!e[0].isIntersecting;
    if(nv)nv.classList.toggle('x-on',out);
    if(cb)cb.classList.toggle('x-on',out);
  },{rootMargin:'-60px 0px 0px'}).observe(hr);
}else{if(nv)nv.classList.add('x-on');if(cb)cb.classList.add('x-on')}

/* ---------- 6. PARALLAX (solo desktop) + BARRA DE PROGRESO ---------- */
var pxq=window.matchMedia('(min-width:1001px)'),
    pxs=r.querySelectorAll('[data-px]'),tk=false;
function onScroll(){
  if(pg){
    var h=r.offsetHeight-window.innerHeight;
    pg.style.width=(h>0?Math.min(1,Math.max(0,(window.pageYOffset-r.offsetTop)/h))*100:0)+'%';
  }
  if(!rm&&pxq.matches)pxs.forEach(function(el){
    var b=el.parentElement.getBoundingClientRect();
    if(b.bottom<0||b.top>window.innerHeight)return;
    el.style.transform='translate3d(0,'+((b.top+b.height/2-window.innerHeight/2)*-.09)+'px,0)';
  });
}
window.addEventListener('scroll',function(){
  if(!tk){tk=true;requestAnimationFrame(function(){onScroll();tk=false})}
},{passive:true});
onScroll();

/* ---------- 7. ACORDEONES (accesibles) ---------- */
var uid=0;
r.querySelectorAll('[data-acc]').forEach(function(a){
  var items=[];
  a.querySelectorAll('.x-h').forEach(function(h){
    var it=h.parentElement,b=it.querySelector('.x-b'),n=++uid,
        id='xt-ac-'+n,hid='xt-ah-'+n;
    b.id=id;b.setAttribute('role','region');b.setAttribute('aria-labelledby',hid);
    h.id=hid;h.setAttribute('aria-expanded','false');h.setAttribute('aria-controls',id);
    items.push(it);
    h.addEventListener('click',function(){
      var open=it.classList.contains('x-o');
      items.forEach(function(o){
        o.classList.remove('x-o');
        o.querySelector('.x-b').style.maxHeight=null;
        o.querySelector('.x-h').setAttribute('aria-expanded','false');
      });
      if(!open){
        it.classList.add('x-o');
        b.style.maxHeight=b.scrollHeight+'px';
        h.setAttribute('aria-expanded','true');
      }
    });
  });
});
/* recalcula alto al rotar/redimensionar */
function reflowAcc(){
  r.querySelectorAll('.x-o .x-b').forEach(function(b){b.style.maxHeight=b.scrollHeight+'px'});
}

/* ---------- 8. CARRUSEL ---------- */
var tr=r.querySelector('[data-track]'),bar=r.querySelector('[data-bar]'),
    nav=r.querySelectorAll('[data-car]'),upd=function(){};
if(tr){
  var step=function(){
    var c=tr.querySelector('.x-hs-c');
    return c?c.offsetWidth+(parseFloat(getComputedStyle(tr).columnGap||getComputedStyle(tr).gap)||18):320;
  };
  upd=function(){
    var m=tr.scrollWidth-tr.clientWidth,
        p=m>0?tr.scrollLeft/m:0,
        vis=Math.min(1,tr.clientWidth/tr.scrollWidth);
    if(bar){bar.style.width=(vis*100)+'%';bar.style.transform='translateX('+(p*(100/vis-100))+'%)'}
    nav.forEach(function(b){
      b.disabled=(+b.dataset.car<0)?tr.scrollLeft<4:tr.scrollLeft>m-4;
    });
  };
  nav.forEach(function(b){b.addEventListener('click',function(){
    tr.scrollBy({left:step()*(+b.dataset.car),behavior:rm?'auto':'smooth'});
  })});
  tr.addEventListener('scroll',function(){requestAnimationFrame(upd)},{passive:true});
  /* arrastre con mouse (el touch usa el scroll nativo) */
  var dn=false,sx=0,sl=0,mv=0;
  tr.addEventListener('pointerdown',function(e){
    if(e.pointerType==='touch')return;
    dn=true;mv=0;sx=e.clientX;sl=tr.scrollLeft;tr.setPointerCapture(e.pointerId);
  });
  tr.addEventListener('pointermove',function(e){
    if(!dn)return;var d=e.clientX-sx;mv=Math.abs(d);
    if(mv>4)tr.classList.add('x-drag');
    tr.scrollLeft=sl-d;
  });
  ['pointerup','pointercancel','pointerleave'].forEach(function(ev){
    tr.addEventListener(ev,function(){
      if(!dn)return;dn=false;tr.classList.remove('x-drag');
      if(mv>4){var s=step();tr.scrollTo({left:Math.round(tr.scrollLeft/s)*s,behavior:'smooth'})}
    });
  });
  tr.addEventListener('keydown',function(e){
    if(e.key==='ArrowRight'){e.preventDefault();tr.scrollBy({left:step(),behavior:'smooth'})}
    if(e.key==='ArrowLeft'){e.preventDefault();tr.scrollBy({left:-step(),behavior:'smooth'})}
  });
  upd();setTimeout(upd,600);
}

/* ---------- 9. RESIZE / ROTACIÓN ---------- */
var rt=false;
window.addEventListener('resize',function(){
  if(rt)return;rt=true;
  requestAnimationFrame(function(){rt=false;reflowAcc();upd();onScroll()});
},{passive:true});

/* ---------- 10. ANCLAS CON OFFSET REAL DEL NAV ---------- */
r.querySelectorAll('a[href^="#"]').forEach(function(a){
  a.addEventListener('click',function(ev){
    var t=r.querySelector(a.getAttribute('href'));if(!t)return;
    ev.preventDefault();
    var off=(nv&&getComputedStyle(nv).display!=='none'&&nv.classList.contains('x-on'))?nv.offsetHeight:0;
    window.scrollTo({top:t.getBoundingClientRect().top+window.pageYOffset-off-8,
                     behavior:rm?'auto':'smooth'});
  });
});

/* red de seguridad por si el bloque se inyecta tarde */
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',hydrate);
})();